module.exports = __webpack_public_path__ + "img/no-team-members.0d8d73f5.png";